export default __webpack_public_path__ + "static/media/chilled-acoustic-indie-folk-instrumental-background-music-for-videos-5720.afe72a23.mp3";